import type { IAddOfferToComparisonResponse } from '../../../../repositories/offers-comparison/entities/add_offer_to_comparison/AddOfferToComparisonResponse';
import type { TAddOfferToComparisonResponse } from '../../../../repositories/offers-comparison/v2/add-offer-to-comparison';
import type { FetchResponse } from '@cian/http-api';

export const mapDeleteOfferFromComparisonResponse = (
  response: IAddOfferToComparisonResponse,
): FetchResponse<TAddOfferToComparisonResponse> => {
  return {
    statusCode: 200,
    headers: [] as unknown as Headers,
    response,
  };
};
